import React from 'react';

export const PhoneSlash = ({ width = 16, height = 16, className = '' }) => (
  <svg
    width={width}
    height={height}
    className={className}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_41357_251449)">
      <path
        d="M2 14L14 2"
        stroke="#6B7280"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.88733 9.44069C2.76964 7.83531 2.11656 5.95268 2 4.00002C2 3.6464 2.14048 3.30726 2.39052 3.05721C2.64057 2.80716 2.97971 2.66669 3.33333 2.66669H6L7.33333 6.00002L5.66667 7.00002C5.73867 7.14669 5.81533 7.29002 5.89667 7.43002M7.064 8.94802C7.626 9.50802 8.27867 9.97735 9 10.3334L10 8.66669L13.3333 10V12.6667C13.3333 13.0203 13.1929 13.3594 12.9428 13.6095C12.6928 13.8595 12.3536 14 12 14C9.39874 13.8443 6.94502 12.7397 5.104 10.8954"
        stroke="#6B7280"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_41357_251449">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
